<template>
  <teleport to="body">
  <div
    :class="['overlay_popup', { is_over: props.isOverlay }]"
    v-if="props.isVisible"
    @click.self="overlayClickHandler"
  >
    <div
      :class="['modal_wrap', { [props.customClass]: props.customClass }]"
      :style="{
        width: defaultWidth,
        height: defaultHeight,
        maxWidth: defaultMaxWidth,
        maxHeight: defaultMaxHeight,
      }"
    >
      <slot></slot>
    </div>
  </div>
  </teleport>
</template>

<script setup>
import { defineProps, defineEmits, watch } from "vue";
const emit = defineEmits(["closeDialogHandler"]);
const props = defineProps({
  isVisible: { type: Boolean },
  width: { type: String },
  height: { type: String },
  maxWidth: { type: String },
  maxHeight: { type: String },
  isOverlay: { type: Boolean },
  customClass: { type: String },
});

const defaultWidth = props.width || "fit-content";
const defaultHeight = props.height || "fit-content";
const defaultMaxWidth = props.maxWidth || "100%";
const defaultMaxHeight = props.maxHeight || "100%";

const body = document.querySelector("body");

if (body && props.isVisible) {
  body.style.overflow = "hidden";
}
const overlayClickHandler = () => {
  if (props.isOverlay) {
    emit("closeDialogHandler");
  }
};
watch(
  () => props.isVisible,
  (value) => {
    if (body && !value) {
      body.style.overflow = "auto";
    } else {
      body.style.overflow = "hidden";
    }
  }
);
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/common/modal.scss";

</style>
